export const conditionalItems = {
  title: 'Conditional items',
  resourceName: 'Conditional items',
  titles: {
    list: 'Conditional item list',
    create: 'Create conditional item',
    edit: 'Edit conditional item',
    addQuick: 'Add quick',
  },
  sections: {
    basic: 'Basic information',
    linkage: 'Company linkage',
    validity: 'Validity and status',
    note: 'Notes',
    audit: 'System information',
  },
  units: {
    days: 'days',
  },
  fields: {
    code: 'Conditional item code',
    name: 'Conditional item name',
    conditionGroup: 'Conditional item group',
    groupName: 'Group',
    conditionName: 'Condition name',
    productCode: 'Linked product',
    sampleItem: 'Sample item',
    registeredCompany: 'Registered company',
    exporterCompany: 'Exporter company',
    importerCompany: 'Importer company',
    sampleTestRequired: 'Sample test required',
    certificate: 'Certificate',
    licenseNumber: 'License number',
    effectiveDate: 'Effective date',
    expiryDate: 'Expiry date',
    warningDays: 'Warning time',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    status: 'Status',
    onOffAction: 'On / Off',
    note: 'Note',
    remark: 'Remark',
    actions: 'Actions',
  },
  filter: {
    country: 'Company country',
    allCountries: 'All',
  },
  countries: {
    VN: 'Vietnam',
    TQ: 'China',
  },
  status: {
    active: 'Active',
    inactive: 'Inactive',
    required: 'Required',
    notRequired: 'Not required',
  },
  validation: {
    conditionNameRequired: 'Please enter condition name',
    companyRequired: 'Please select all 3 companies',
  },
  messages: {
    importDescription: 'Choose the correct Excel template to import conditional items.',
    importSuccess: 'Conditional items imported successfully',
    importFailed: 'Conditional item import failed',
    exportSuccess: 'Export completed successfully',
    exportFailed: 'Export failed',
    noData: 'No conditional item data',
    totalItems: 'Total: {total} conditional items',
    createSuccess: 'Conditional item created successfully',
    updateSuccess: 'Conditional item updated successfully',
    deleteSuccess: 'Conditional item deleted successfully',
    confirmDelete: 'Are you sure you want to delete this item?',
  },
  import: {
    button: 'Import',
    noSheet: 'No worksheet found in import file',
    noData: 'No data to import',
    success: 'Imported {count} rows successfully',
    failed: 'Import failed',
  },
}
